module.exports = __webpack_public_path__ + "img/Photo30.57f11ecc.jpg";